import _ from 'lodash';
import React, {FC} from 'react';
import {connect} from 'react-redux';

import {useInitialEffect} from '../../../../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
  ResolveStateProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {ResolveDispatchProps} from '../../../../helpers/reduxHelpers';
import {CustomFieldResourceTypesEnum} from '../../../../models/api/customFieldModel';
import {fetchCustomFieldsForResourceTypeAsyncAction} from '../../../../store/data/customFields/customFieldsActions';
import {getCustomFields} from '../../../../store/data/dataSelectors';
import {CrmMapping, CrmMappingProps} from './crmMapping';

/*
 * Props.
 */

interface CrmMappingContainerProps extends Omit<CrmMappingProps, 'customFields'> {}

/*
 * Components.
 */

export const CrmMappingContainerComponent: FC<
  CrmMappingContainerProps &
    ResolveStateProps<typeof mapStateToProps> &
    ResolveDispatchProps<typeof mapDispatchToProps>
> = (props) => {
  const {
    source,
    requiredFields,
    customFields,
    isDisabled,
    mappedFields,
    isLoading,
    isAdmin,
    onRemoveMappedField,
    computeCrmCustomFieldName,
    computeCrmCustomFieldIcon,
    fetchCustomFieldsForResourceType,
    renderAddFieldDropdown,
    onUpdateMappedField,
    computeFrontTypesFromCrmCustomField,
    renderCrmCustomFieldMissingError,
    renderCrmPlaceholder,
  } = props;

  // Maybe fetch account custom fields if they are not loaded yet, this could happen if they go directly to
  // settings without opening contacts manager or P4 contact details.
  useInitialEffect(() => {
    if (
      _(customFields)
        .values()
        .some((customField) => customField?.resourceType === CustomFieldResourceTypesEnum.ACCOUNT)
    ) {
      return;
    }
    fetchCustomFieldsForResourceType(CustomFieldResourceTypesEnum.ACCOUNT);
  });

  return (
    <CrmMapping
      source={source}
      requiredFields={requiredFields}
      customFields={customFields}
      isDisabled={isDisabled}
      mappedFields={mappedFields}
      isLoading={isLoading}
      isAdmin={isAdmin}
      onRemoveMappedField={onRemoveMappedField}
      computeCrmCustomFieldName={computeCrmCustomFieldName}
      computeCrmCustomFieldIcon={computeCrmCustomFieldIcon}
      renderAddFieldDropdown={renderAddFieldDropdown}
      onUpdateMappedField={onUpdateMappedField}
      computeFrontTypesFromCrmCustomField={computeFrontTypesFromCrmCustomField}
      renderCrmCustomFieldMissingError={renderCrmCustomFieldMissingError}
      renderCrmPlaceholder={renderCrmPlaceholder}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  customFields: getCustomFields,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchCustomFieldsForResourceType: fetchCustomFieldsForResourceTypeAsyncAction,
}));

export const CrmMappingContainer = connect(mapStateToProps, mapDispatchToProps)(CrmMappingContainerComponent);
